


























import { vxm } from '@/store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class MissingMandatoryStep extends Vue {
  @Prop({ default: '' }) selectedSection;
  get missedSteps() {
    return vxm.users.RequiredStepsInfo.requiredStepsMissing;
  }
  stepNameTextMapping(step) {
    const textMapping = {
      skills: 'Skills/Specialties',
      education_history: 'Education History',
      work_experience: 'Work Experience',
      professional_reference: 'Professional References',
      'certification-questioner': 'Certification Questionnaire',
      resume: 'Resume',
      source_type: 'Source',
      address: 'Address',
      protected_information: 'Protected Information',
      job_preference: 'Job Preference',
      were_you_referred: 'Were you referred?',
    };
    return textMapping[step] || step;
  }
}
